export default __webpack_public_path__ + "media/images/mail/xing-3058d269b1ede019b22ff7246218e07c.png";